import React from 'react'

function AddCollege(props) {
  return (
    <svg
      width="58"
      height="57"
      viewBox="0 0 58 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        cursor: props.onClick ? 'pointer' : undefined,
        ...(props.style || {}),
      }}
      onClick={props.onClick}
    >
      <g filter="url(#filter0_d_1_10013)">
        <rect x="2" y="1" width="54" height="53" fill="#FBFAFF" />
        <rect x="2.5" y="1.5" width="53" height="52" stroke="#E3DEFF" />
        <path
          d="M23 27.5H29M29 27.5H35M29 27.5V33.5M29 27.5V21.5"
          stroke="#3249D7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1_10013"
          x="0"
          y="0"
          width="58"
          height="57"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1_10013"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1_10013"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default AddCollege
